import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";
import { Slide } from "pure-react-carousel";
import {
  disableAllMenu,
  expandImageUrl,
  expandImageAlt,
  isActiveExpandImageModal,
} from "modules/actions/statusMenu";
import { useDispatch } from "react-redux";
import CarouselSlider from "components/atoms/TemplateCarouselSlider";
/**
 * Large_CardDefault
 */
const LargeCard = ({ boxStyle, item, viewType, onClickEvt }) => {
  const dispatch = useDispatch();
  const { items } = item;
  const slideBoxSet = boxStyle;
  const { fontSize } = boxStyle;
  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: slideBoxSet.height,
    margin: `0 ${slideBoxSet.margin}px`,
  };
  const slideLength = items.length;
  const expandImage = (url, alt) => {
    // event.currentTarget.src = 'images/noimage.png';
    // event.currentTarget.className = 'errorImg';
    // event.currentTarget.alt = '이미지 로드 실패';

    dispatch(disableAllMenu());
    dispatch(isActiveExpandImageModal(true));
    dispatch(expandImageUrl(url));
    dispatch(expandImageAlt(alt));
  };

  const revertImageTag = (imgTag, imgAlt) => {
    const src = imgTag.replace('<img src="', '').replace('"></img>', '');
    return <img src={src} alt={imgAlt} />;
  }
  
  useEffect(() => {
    // Remove tabIndex from carousel items when component mounts
    const removeTabIndex = () => {
      const liElements = document.querySelectorAll('.carousel__slider li');
      liElements.forEach(li => {
        li.removeAttribute('tabindex');
        li.removeAttribute('role');
        li.removeAttribute('aria-selected');
      });
    };
    removeTabIndex();
  }, []);

  const constentSet = () => {
    return (
      <>
        {items.map((tempItem, idx) => {
          let htmlCheck = false;
          if (tempItem.image.image.includes("<img")) {
            htmlCheck = true;
          }
          const tempImage = ReactHtmlParser(tempItem.image.image);
          return (
            <Slide
              key={`slide_${idx}`}
              className="_large_card"
              style={slideBoxSetStyle}
            >
               <div className="_title">
                <h2 className="_h2_title">
                  {tempItem.text.desc}
                </h2>
              </div>
              <div className="_cont_image">
                <div
                  className="_image_box"
                  style={{ cursor: "pointer" }}
                  role="link"
                  tabIndex="0"
                  title="버튼을 실행하면 새 창으로 이미지가 확대됩니다"
                  onClick={() => {
                    expandImage(
                      (htmlCheck
                        ? tempItem.image.image
                            .replace('<img src="', "")
                            .replace('"></img>', "")
                        : tempItem[type].image),
                        tempItem.image.alt
                    );
                  }}
                >
                  {/* {tempImage} */}
                  {/* <img src={tempItem.image.image} alt={tempItem.image.alt} /> */}
                  {revertImageTag(tempItem.image.image, tempItem.image.alt)}
                </div>
              </div>
              <div className="_desc_box">
                 <div className="_desc" style={{ fontSize }} aria-label={tempItem.textbox.desc} >{tempItem.textbox.desc}</div>
              </div>
              {tempItem.button.label !== "" ? (
                <div
                  className="link_div"
                  onClick={(e) =>
                    onClickEvt(tempItem.button.value, tempItem.button.action)
                  }
                >
                  <div className="_link_box" aria-label={tempItem.button.label}>{tempItem.button.label}</div>
                </div>
              ) : (
                ""
              )}
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div">
        <CarouselSlider
          slideBoxSet={slideBoxSet}
          contentCount={slideLength}
          contentSet={constentSet}
        />
      </div>
    </>
  );
};

LargeCard.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
LargeCard.defaultProps = {
  boxStyle: { width: 150, margin: 10, height: "220px" },
  item: {},
  viewType: "advise", // advise, simulator, knowledge
  onClickEvt: null,
};

export default LargeCard;
